import API from 'my-core/api';
import standardApiRequestAction from 'my-core/standardApiRequestAction';

import types from '../constants/OnlineCourseUserActionTypes';

export function fetchOnlineCourseUsers(params = {}, fetchKey, page = 0) {
  return dispatch => {
    API.getJSON('/online_course_users', { ...params, page })
      .then(({ items, total }) => {
        dispatch({ type: types.FETCH_ONLINE_COURSE_USERS_SUCCESS, items, total, fetchKey, page });
      })
      .catch(error => {
        console.error(error);
        dispatch({ type: types.FETCH_ONLINE_COURSE_USERS_FAIL, fetchKey, error });
      });
  };
}

export function fetchOnlineCourseUsersApi(params, requestKey, page = 0) {
  return standardApiRequestAction({
    path: '/api/v1/online_course_users',
    body: params,
    parentRequestKey: requestKey,
    requestKey: page,
  });
}

export function fetchUserOnlineCourseUsers(userId, fetchParams, requestKey) {
  return standardApiRequestAction({
    path: `/api/v1/online_course_users/for_user/${userId}`,
    body: fetchParams,
    requestKey,
  });
}

export function createOnlineCourseUser(ocId) {
  return standardApiRequestAction({
    path: `/api/v1/online_courses/${ocId}/users`,
    method: 'post',
  });
}

export function updateOnlineCourseUser(onlineCourseUserId, params) {
  return dispatch => {
    API.putJSON(`/online_course_users/${onlineCourseUserId}`, { online_course_user: params })
      .then(onlineCourseUser => {
        dispatch({ type: types.UPDATE_ONLINE_COURSE_USER_SUCCESS, onlineCourseUser });
      })
      .catch(error => {
        console.error(error);
        dispatch({ type: types.UPDATE_ONLINE_COURSE_USER_FAIL, error });
      });
  };
}

export function updateOnlineCourseUserProgress(onlineCourseUserId, progress) {
  return dispatch => {
    dispatch({ type: types.UPDATE_ONLINE_COURSE_USER_PROGRESS, id: onlineCourseUserId, progress });
    API.patchJSON(`/online_course_users/${onlineCourseUserId}/progress`, { progress })
      .then(() => {
        dispatch({ type: types.UPDATE_ONLINE_COURSE_USER_PROGRESS_SUCCESS, id: onlineCourseUserId, progress });
      })
      .catch(error => {
        console.error(error);
        dispatch({ type: types.UPDATE_ONLINE_COURSE_USER_PROGRESS_FAIL, id: onlineCourseUserId, error });
      });
  };
}

export function purchaseOnlineCourseUser(onlineCourseId, params) {
  return dispatch => {
    API.postJSON('/online_course_users/purchase', { online_course_id: onlineCourseId, online_course_user: params })
      .then(({ online_course: onlineCourse, online_course_user: onlineCourseUser, user }) => {
        dispatch({ type: types.PURCHASE_ONLINE_COURSE_USER_SUCCESS, onlineCourseUser, onlineCourse, user });
      })
      .catch(error => {
        console.error(error);
        dispatch({ type: types.PURCHASE_ONLINE_COURSE_USER_FAIL, error });
      });
  };
}

export function incrementOnlineCourseUserRemainingQuestions(onlineCourseUserId) {
  return dispatch => {
    API.patchJSON(`/online_course_users/${onlineCourseUserId}/increment_questions_count`)
      .then(onlineCourseUser => {
        dispatch({ type: types.UPDATE_ONLINE_COURSE_USER_SUCCESS, onlineCourseUser });
      })
      .catch(error => {
        console.error(error);
        dispatch({ type: types.UPDATE_ONLINE_COURSE_USER_FAIL, error });
      });
  };
}

export function deleteOnlineCourseUser(onlineCourseUserId) {
  return dispatch => {
    API.deleteJSON(`/online_course_users/${onlineCourseUserId}`)
      .then(() => {
        dispatch({ type: types.DELETE_ONLINE_COURSE_USER_SUCCESS, id: onlineCourseUserId });
      })
      .catch(error => {
        console.error(error);
        dispatch({ type: types.DELETE_ONLINE_COURSE_USER_FAIL, error });
      });
  };
}

export function refundOnlineCourseUser(onlineCourseUserId, amount) {
  return dispatch => {
    API.patchJSON(`/online_course_users/${onlineCourseUserId}/refund`, { amount })
      .then(onlineCourseUser => {
        dispatch({ type: types.REFUND_ONLINE_COURSE_USER_SUCCESS, onlineCourseUser, amount });
      })
      .catch(error => {
        console.error(error);
        dispatch({ type: types.REFUND_ONLINE_COURSE_USER_FAIL, error });
      });
  };
}

export function addUserToOnlineCourse(userId, onlineCourseId) {
  return dispatch => {
    API.putJSON('/online_course_users/add_user_to_online_course', { user_id: userId, online_course_id: onlineCourseId })
      .then(onlineCourseUser => {
        dispatch({ type: types.ADD_USER_TO_ONLINE_COURSE_SUCCESS, onlineCourseUser, onlineCourseId, userId });
      })
      .catch(error => {
        console.error(error);
        dispatch({ type: types.ADD_USER_TO_ONLINE_COURSE_FAIL, error, onlineCourseId, userId });
      });
  };
}

export function sendOnlineCourseUserReceipt(onlineCourseUserId) {
  return dispatch => {
    API.getJSON(`/online_course_users/${onlineCourseUserId}/send_receipt`)
      .then(() => {
        dispatch({ type: types.SEND_ONLINE_COURSE_USER_RECEIPT_SUCCESS, onlineCourseUserId });
      })
      .catch(error => {
        dispatch({ type: types.SEND_ONLINE_COURSE_USER_RECEIPT_FAIL, error });
      });
  };
}

export function expireAllOnlineCourseUserAccess(onlineCourseId) {
  const requestKey = `expire_all_${onlineCourseId}_${Date.now()}`;
  return dispatch => {
    API.postJSON('/api/v1/online_course_users/expire_all', { online_course_id: onlineCourseId })
      .then(onlineCourseUserIds => {
        dispatch({ type: types.EXPIRE_ALL_ONLINE_COURSE_USER_ACCESS_SUCCESS, onlineCourseUserIds, requestKey });
      })
      .catch(error => {
        dispatch({ type: types.EXPIRE_ALL_ONLINE_COURSE_USER_ACCESS_FAIL, error, requestKey });
      });
  };
}

export function expireOnlineCourseUserAccess(onlineCourseUserId) {
  return standardApiRequestAction({
    path: `/api/v1/online_course_users/${onlineCourseUserId}/expire_access`,
    method: 'patch',
  });
}

export function grantOnlineCourseUserFullAccess(onlineCourseUserId) {
  return standardApiRequestAction({
    path: `/api/v1/online_course_users/${onlineCourseUserId}/grant_full_access`,
    method: 'patch',
  });
}
